import React from 'react';
import ProgressBar from '../common/ProgressBar';
import { formatUSDT, toNumberSafe, formatDate } from '../../utils/format';

const TYPE_LABEL = { 0: 'Real', 1: 'Virtual', 2: 'Migrated' };

export default function InvestmentRow({ inv }) {
  const earned = toNumberSafe(inv.roiEarned) + toNumberSafe(inv.levelIncomeEarned);
  const ceiling = toNumberSafe(inv.ceilingAmount);
  const pct = ceiling > 0 ? (earned / ceiling) * 100 : 0;

  return (
    <div className="investment-item">
      <div className="thumb">{formatUSDT(inv.amount, { decimals: 0 })}</div>
      <div className="info">
        <div className="top">
          <div className="amt">{formatUSDT(inv.amount)}</div>
          <span className={`badge ${inv.active ? 'success' : 'mute'}`}>
            {inv.active ? 'Active' : 'Filled'}
          </span>
        </div>
        <div className="earned">
          Earned {formatUSDT(inv.roiEarned.add ? inv.roiEarned.add(inv.levelIncomeEarned) : (Number(inv.roiEarned) + Number(inv.levelIncomeEarned)))}
          {' / '} {formatUSDT(inv.ceilingAmount)}
        </div>
        <div className="progress mt-8"><ProgressBar value={pct} max={100} /></div>
        <div className="text-mute" style={{ fontSize: 10.5, marginTop: 4 }}>
          {TYPE_LABEL[inv.investmentType] || '—'} · {formatDate(inv.timestamp)}
        </div>
      </div>
    </div>
  );
}
